import { type ReactNode } from 'react'
import cn from 'classnames'
import { type CmHeroPrice } from 'pages/certificates/experiments/mccerts-2548_v1-subscriptions-entry-point'

type PassPriceLockupProps = CmHeroPrice & {
  note?: ReactNode
}

// Annual Pass price for the pass-only hero: the list price struck through and
// the featured price on the lime highlight, but only while a discount applies
// (originalPrice is set only then); the plain list price otherwise.
export const PassPriceLockup = ({
  finalPrice,
  originalPrice,
  note,
}: PassPriceLockupProps) => {
  if (!finalPrice) return null

  return (
    <p className='c-heading-4 flex items-baseline justify-center gap-2'>
      {originalPrice && <s className='text-c-text-tint-2'>{originalPrice}</s>}
      <span
        className={cn('text-c-text-dark', {
          'bg-c-brand-highlight px-1': !!originalPrice,
        })}
      >
        {finalPrice}
      </span>
      {note && (
        <span className='c-body-small text-c-text-tint-3 md:text-c-text-dark'>
          {note}
        </span>
      )}
    </p>
  )
}
